import React, { useState, useEffect } from 'react';
import { SITE_LOGO_ALT } from '../constants/siteBranding';
import './PageLoader.css';

const LOADER_TEXTS = [
  'Professional Housekeeping Services',
  'Facility Management Solutions',
  'Clean • Safe • Hygienic Workspaces'
];

function PageLoader({ onFinish, minDisplayTime = 2000, rotatingText = true }) {
  const [textIndex, setTextIndex] = useState(0);
  const [textFade, setTextFade] = useState(true);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    let textInterval;
    let doneTimer;

    if (rotatingText && LOADER_TEXTS.length > 1) {
      textInterval = setInterval(() => {
        setTextFade(false);
        setTimeout(() => {
          setTextIndex((i) => (i + 1) % LOADER_TEXTS.length);
          setTextFade(true);
        }, 280);
      }, 1800);
    }

    const fadeOutDuration = 450;
    const finishTimer = setTimeout(() => {
      if (textInterval) clearInterval(textInterval);
      setExiting(true);
      doneTimer = setTimeout(() => onFinish?.(), fadeOutDuration);
    }, minDisplayTime);

    return () => {
      if (textInterval) clearInterval(textInterval);
      clearTimeout(finishTimer);
      clearTimeout(doneTimer);
    };
  }, [onFinish, minDisplayTime, rotatingText]);

  return (
    <div className={`page-loader ${exiting ? 'page-loader--exiting' : ''}`} role="status" aria-label="Loading">
      <div className="page-loader-bg" />
      <div className="page-loader-content">
        <div className="page-loader-logo">
          <img
            src={`${process.env.PUBLIC_URL || ''}/KHP_LOGO.svg`}
            alt={SITE_LOGO_ALT}
          />
        </div>
        <p className={`page-loader-text ${textFade ? 'page-loader-text--visible' : 'page-loader-text--hidden'}`}>
          {LOADER_TEXTS[textIndex]}
        </p>
        <div className="page-loader-line" aria-hidden="true">
          <div className="page-loader-line-fill" />
        </div>
      </div>
    </div>
  );
}

export default PageLoader;
